import React, { DetailedHTMLProps } from 'react'

export default function CardFooter({ children, className, ...props }: DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
) {
    return (
        <div className={'card-footer' + (className ? ` ${className}` : '')} {...props}>
            {children}
        </div>
    )
}
